module.exports = __webpack_public_path__ + "static/media/googlegbm-large2.bb22e063.svg";